import React from "react";
import "./Contact.css";



const Contact = () => {
    return (
        <div className="premium-contact-page">


            {/* CONTACT SECTION */}

            <section className="premium-contact-section">

                <div className="contact-overlay"></div>

                <div className="container">

                    <div className="premium-contact-content">

                      

                        <h2>
                            Trusted Pest Control
                            Solutions Near You
                        </h2>

                        <p className="contact-desc">
                            Our expert team is ready to inspect,
                            protect and provide effective pest
                            treatment solutions for your home,
                            office and commercial spaces.
                        </p>

                        {/* CARDS */}

                        <div className="contact-info-grid">

                            

                                {/* ADDRESS FULL WIDTH */}

                                <div className="contact-info-card address-card">
                                    <div className="contact-icon">
                                        <i className="fa-solid fa-location-dot"></i>
                                    </div>

                                    <div>
                                        <h4>Address</h4>

                                        <p>
                                            Total Pest Control
                                            Lane 3, vishwashanti colony,
                                            Pimple Saudagar, Near Cream & Stone
                                            Pune - 411027 Maharashtra, INDIA
                                        </p>
                                    </div>
                                </div>

                                {/* BOTTOM 2 CARDS */}

                                <div className="bottom-contact-cards">

                                    <div className="contact-info-card">
                                        <div className="contact-icon">
                                            <i className="fa-solid fa-phone"></i>
                                        </div>

                                        <div>
                                            <h4>Phone</h4>

                                            <p>
                                                +91 9822290400 &nbsp; | &nbsp;  
                                                +91 7666996177
                                            </p>
                                        </div>
                                    </div>

                                    <div className="contact-info-card">
                                        <div className="contact-icon">
                                            <i className="fa-solid fa-envelope"></i>
                                        </div>

                                        <div>
                                            <h4>Email</h4>

                                            <p>
                                                info@totalpestcontrol.co.in
                                            </p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                

            </section>

            {/* MAP */}

            <section className="premium-map-section">

                <div
               
                >

                    <div className="premium-map-box">

                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.5026341016323!2d73.79667697519349!3d18.596448782511878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9677b48a9f1%3A0xba4e47750eeb4028!2sTotal%20pest%20control!5e0!3m2!1sen!2sin!4v1775634539791!5m2!1sen!2sin"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>

                    </div>

                </div>

            </section>

        </div>
    );
};

export default Contact;